import React from 'react';
import wcLogo from '../../assets/wc_logo.png';
import './HeaderWC26.css';

function HeaderWC26() {
  return (
    <div className="header-wc26-wrapper">
      <header className="header-wc26">
        <div className="header-wc26-logo">
          <img src={wcLogo} alt="World Cup 2026 logo" />
          <p>World Cup 2026 Sweepstakes</p>
        </div>
        <nav className="header-wc26-nav">
          <ul>
            <li><a href="/wc26">Home</a></li>
            <li><a href="/wc26-bracket">Bracket</a></li>
          </ul>
        </nav>
      </header>
      <div className="header-wc26-fade" />
    </div>
  );
}

export default HeaderWC26;
